import axios from 'axios';

const buildOrgLibraryPath = (orgId, path) => (
  orgId
    ? `/api/internal/orgs/${orgId}/library${path}`
    : `/api/library${path}`
);

export const libraryApi = {
  getQuestionsStats(params = {}) {
    const { page = 1, limit = 20, search, type } = params;
    return axios
      .get('/api/library/questions-stats', {
        params: { page, limit, search, type },
      })
      .then((r) => r.data);
  },
  getAssessmentsStats(params = {}) {
    const { orgId, page = 1, limit = 20, search, category, difficulty } = params;
    const url = buildOrgLibraryPath(orgId, '/assessments-stats');
    return axios
      .get(url, {
        params: { page, limit, search, category, difficulty },
      })
      .then((r) => r.data);
  },
  getAssessmentsFilters(options = {}) {
    const url = buildOrgLibraryPath(options.orgId, '/assessments-filters');
    return axios.get(url).then((r) => r.data);
  },
  deleteLibraryAssessment(id) {
    return axios.delete(`/api/library/assessments/${id}`).then((r) => r.data);
  },
  getLibraryAssessmentById(id, options = {}) {
    const url = buildOrgLibraryPath(options.orgId, `/assessments/${id}`);
    return axios.get(url).then((r) => r.data);
  },
  updateLibraryAssessment(id, payload) {
    return axios.put(`/api/library/assessments/${id}`, payload).then((r) => r.data);
  },
  getAIInterviewsStats(params = {}) {
    const { orgId, page = 1, limit = 20, search, category, difficulty, advancedType } = params;
    const url = buildOrgLibraryPath(orgId, '/ai-interviews-stats');
    return axios
      .get(url, {
        params: { page, limit, search, category, difficulty, advancedType },
      })
      .then((r) => r.data);
  },
  getAIInterviewById(id, options = {}) {
    const url = buildOrgLibraryPath(options.orgId, `/ai-interviews/${id}`);
    return axios.get(url).then((r) => r.data);
  },
  updateLibraryAIInterview(id, payload) {
    return axios.put(`/api/library/ai-interviews/${id}`, payload).then((r) => r.data);
  },
  getLibraryAIInterviewImpact(id) {
    return axios.get(`/api/library/ai-interviews/${id}/impact`).then((r) => r.data);
  },
  deleteLibraryAIInterview(id) {
    return axios.delete(`/api/library/ai-interviews/${id}`).then((r) => r.data);
  },
};
